import { useState, useEffect, useCallback } from "react"

const useCustomColors = (load, save, { resetOnMount = false } = {}) => {
  const [customColors, setCustomColors] = useState(() => (resetOnMount ? {} : load()))

  const handleColorChange = useCallback((index, color) => {
    setCustomColors((prev) => {
      if (color === null) {
        const { [index]: _, ...rest } = prev
        return rest
      }
      return { ...prev, [index]: color }
    })
  }, [])

  const handleResetAllColors = useCallback(() => setCustomColors({}), [])

  useEffect(() => {
    save(customColors)
  }, [customColors, save])

  return { customColors, setCustomColors, handleColorChange, handleResetAllColors }
}

export default useCustomColors
